module.exports = InternalShared('InternalShared/PageBuilder/DragAndDrop/GroupManager');